/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {ModalReact} from 'common/components/modal';
import {
  getImmersiveOnboardingSetupGuideInfo,
  ImmersiveOnboardingResult,
} from 'common/report/queries/app-api/immersive-onboarding';

import styles from './index.module.styl';
import {SideNav} from './components';
import {SetupGuideContext, Step, VisibilityContext} from './types';
import {Events, Explore, Implement, Welcome} from './steps';
import {Scrollable, ScrollableElement, scrollToStep} from './components/scroll-manager';

export const ImmersiveOnboarding = () => {
  const [open, setOpen] = React.useState(true);
  const [step, setStep] = React.useState<Step>(null);
  const [setupGuideInfo, setSetupGuideInfo] = React.useState<ImmersiveOnboardingResult>(null);
  const [isIntegrated, setIsIntegrated] = React.useState(false);

  const [visibility, setVisibility] = React.useState(true);

  React.useEffect(
    () => {
      const paths = window.location.pathname.split(`/`);
      const projectId = paths[paths.indexOf(`project`) + 1];
      getImmersiveOnboardingSetupGuideInfo(projectId).then((setupGuideInfo) => {
        setSetupGuideInfo(setupGuideInfo);
      });
      setTimeout(() => {
        setStep(Step.Welcome);
      }, 300); // probably need loading for this?
    },
    [
      /** Mount Effect */
    ],
  );

  React.useEffect(() => {
    scrollToStep(step);
  }, [step]);

  return (
    <VisibilityContext.Provider value={{visibility, setVisibility}}>
      <ModalReact open={open} grow-to-content style={{visibility: visibility ? `visible` : `collapse`}}>
        <SetupGuideContext.Provider value={{open, setOpen, step, setStep, setupGuideInfo, setSetupGuideInfo, isIntegrated, setIsIntegrated}}>
          <div className={styles.layout}>
            <SideNav onClose={() => setOpen(false)} />
            <Scrollable className={styles.rhs}>
              <ScrollableElement name={Step.Welcome} active={step === Step.Welcome}>
                <Welcome />
              </ScrollableElement>
              <ScrollableElement name={Step.Events} active={step === Step.Events}>
                <Events />
              </ScrollableElement>
              <ScrollableElement name={Step.Implement} active={step === Step.Implement}>
                <Implement />
              </ScrollableElement>
              <ScrollableElement name={Step.Explore} active={step === Step.Explore}>
                <Explore />
              </ScrollableElement>
            </Scrollable>
          </div>
        </SetupGuideContext.Provider>
      </ModalReact>
    </VisibilityContext.Provider>
  );
};
